import { addImageParams } from '@/utils/urls';

const IMAGE_QUALITY = 100;
const BANNER_IMAGE_HEIGHT = 240;

const BANNER_IMAGE_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_homepage_banner_asset.png';
const HERO_BANNER_IMAGE_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_hero_banner_image.png';
const STEP_1_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_1_visual.png';
const STEP_2_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_2_visual.png';
const STEP_3_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_3_visual.png';
const STEP_4_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_4_visual.png';
const STEP_5_VISUAL_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_step_5_visual.png';

export const BANNER_GRADIENT_STYLE = {
    background: 'linear-gradient(88deg, rgba(0, 155, 204, 0.30) 0%, rgba(236, 250, 255, 0.30) 100.84%), #C6F1FF',
} as const;

const imageParams = { quality: IMAGE_QUALITY, sharpen: true } as const;

export const BANNER_IMAGE_URL = addImageParams({
    ...imageParams,
    height: BANNER_IMAGE_HEIGHT,
    url: BANNER_IMAGE_BASE_URL,
});

export const BANNER_IMAGE_URL_HIGH_DPI = addImageParams({
    ...imageParams,
    height: BANNER_IMAGE_HEIGHT * 2,
    url: BANNER_IMAGE_BASE_URL,
});

export const HOW_TO_WIN_HERO_BANNER_IMAGE_URL = addImageParams({
    ...imageParams,
    url: HERO_BANNER_IMAGE_BASE_URL,
});

export const HOW_TO_WIN_STEP_1_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_1_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_2_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_2_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_3_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_3_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_4_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_4_VISUAL_BASE_URL,
});

export const HOW_TO_WIN_STEP_5_VISUAL_URL = addImageParams({
    ...imageParams,
    url: STEP_5_VISUAL_BASE_URL,
});

export type Step = {
    descriptionId: string;
    imageAltId: string;
    imageUrl: string;
    number: number;
    proTipId: string;
    titleId: string;
};

export const HOW_TO_WIN_STEPS: Step[] = [
    {
        descriptionId: 'howToWinRedesigned.step1.description',
        imageAltId: 'howToWinRedesigned.step1.imageAlt',
        imageUrl: HOW_TO_WIN_STEP_1_VISUAL_URL,
        number: 1,
        proTipId: 'howToWinRedesigned.proTip.step1',
        titleId: 'howToWinRedesigned.step1.title',
    },
    {
        descriptionId: 'howToWinRedesigned.step2.description',
        imageAltId: 'howToWinRedesigned.step2.imageAlt',
        imageUrl: HOW_TO_WIN_STEP_2_VISUAL_URL,
        number: 2,
        proTipId: 'howToWinRedesigned.proTip.step2',
        titleId: 'howToWinRedesigned.step2.title',
    },
    {
        descriptionId: 'howToWinRedesigned.step3.description',
        imageAltId: 'howToWinRedesigned.step3.imageAlt',
        imageUrl: HOW_TO_WIN_STEP_3_VISUAL_URL,
        number: 3,
        proTipId: 'howToWinRedesigned.proTip.step3',
        titleId: 'howToWinRedesigned.step3.title',
    },
    {
        descriptionId: 'howToWinRedesigned.step4.description',
        imageAltId: 'howToWinRedesigned.step4.imageAlt',
        imageUrl: HOW_TO_WIN_STEP_4_VISUAL_URL,
        number: 4,
        proTipId: 'howToWinRedesigned.proTip.step4',
        titleId: 'howToWinRedesigned.step4.title',
    },
    {
        descriptionId: 'howToWinRedesigned.step5.description',
        imageAltId: 'howToWinRedesigned.step5.imageAlt',
        imageUrl: HOW_TO_WIN_STEP_5_VISUAL_URL,
        number: 5,
        proTipId: 'howToWinRedesigned.proTip.step5',
        titleId: 'howToWinRedesigned.step5.title',
    },
];

export const FREQUENTLY_ASKED_QUESTION_IDS = [
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
] as const;
